// extracted by mini-css-extract-plugin
export default {"buildHistoryBtn":"BuildReport_buildHistoryBtn__hzAYh","backButton":"BuildReport_backButton__Vd4Xa"};